export const SET_PARTICIPANT_QP = "SET_PARTICIPANT_QUERY_PARAMS";
export const SET_USER_QP = "SET_USER_QP";
export const SET_SITE_QP = "SET_SITE_QUERY_PARAMS";
export const SET_TEST_QP = "SET_TEST_QUERY_PARAMS";
export const RESET_TEST_QP = "RESET_TEST_QUERY_PARAMS";
export const SET_UPLOAD_QP = "SET_UPLOAD_QP";
export const SET_STROKE_QP = "SET_STROKE_QP";
export const SET_DASHBOARD_GROUP_QP = "SET_DASHBOARD_GROUP_QP";
